export const prefix = 'garderobo';

export const LStorage = {
    likedProductIds: 'likedProductIds',
};
